import React from 'react'

export default function NavBar() {
  return (
    <div className='navBar flexCol alignItems'>
        <h1> Radio Bar Programmer Meet-up</h1>
    </div>
  )
}
